var React = require('react');

function Blob2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M48.1124 0.00022206C68.5266 0.0606719 85.1987 13.1485 92.4563 30.9179C101.237 52.4154 105.88 79.2567 86.1166 93.0493C65.796 107.23 37.8743 97.6418 18.0947 82.8123C1.4352 70.322 -3.94848 49.524 2.892 30.6526C9.48442 12.4656 27.5007 -0.0608127 48.1124 0.00022206Z","fill":"#E8E8E8"}));
}

Blob2.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = Blob2;

Blob2.default = Blob2;
